/* eslint-disable no-alert, no-console */

import VirtualScroll from 'virtual-scroll'

export default class ScrollTracker {

   constructor(opt) {

      this.handleScroll = this.handleScroll.bind(this)
      this.init()

   }

   init() {


      this.virtual_scroll = new VirtualScroll({
         firefoxMultiplier: 50
      })
      this.virtual_scroll._noKey = true

      this.reset()

      this.cbs = {
         scroll: [],
         scrollend: [],
      }

   }

   reset() {
      this.virtual_scroll._event.deltaX = 0
      this.virtual_scroll._event.deltaY = 0
      this.virtual_scroll._event.y = 0
      this.virtual_scroll._event.x = 0
      this.isScrolling = false
      this.deltaX = 0
      this.deltaY = 0
      this.positionY = 0
      this.positionX = 0
      this.lastScrollY = 0
      this.lastScrollX = 0
   }

   start() {
      this.virtual_scroll.on(this.handleScroll)
   }

   stop() {
      this.virtual_scroll.off(this.handleScroll)
   }

   on(evt, cb) {
      // console.log('added : ' + evt )
      switch (evt) {
         case 'scroll':
            this.cbs.scroll.push(cb)
            break;
         case 'scrollend':
            // console.log('')
            this.cbs.scrollend.push(cb)
            break;
         default:
            console.warn(evt + ' : such event does not exist')
      }
   }

   off(evt, cb) {

      let index = this.cbs[evt].indexOf(cb)
      this.cbs[evt].splice(index, 1)

   }

   handleScroll(e) {
      // console.log('scrollin\'')
      if (this.timeoutScrollEnd) window.clearTimeout(this.timeoutScrollEnd)

      this.deltaX = e.deltaX
      this.deltaY = e.deltaY

      this.positionY += this.deltaY
      this.positionX += this.deltaX
      this.isScrolling = true

      this.timeoutScrollEnd = window.setTimeout(() => {

         this.isScrolling = false
         this.lastScrollPoint = this.virtual_scrollPos

         this.cbs.scrollend.forEach(cb => {
            cb(e)
         });


      }, 60)

      this.cbs.scroll.forEach(cb => {
         cb(e)
      });

   }

   destroy() {
      if (this.timeoutScrollEnd) window.clearTimeout(this.timeoutScrollEnd)
      this.stop()
      this.virtual_scroll.destroy()
   }

}




// WEBPACK FOOTER //
// ./src/kit/ScrollTracker.js